// Sentry Session Replay privacy settings. Replays are masked and carry no request or
// response bodies: all text, inputs and media are masked or blocked, and no API call has its
// headers or bodies captured (only the URL, method, status, timing and sizes Replay always records).
// Sample rates stay in the runtime config (SENTRY_REPLAY_SAMPLE_RATE, SENTRY_ERROR_REPLAY_SAMPLE_RATE).

// Replay records console calls with their arguments serialised up to seven levels deep. An
// Axios error serialises with its request config, which holds the Authorization header and the
// request body, so console breadcrumbs are left out of recordings.
export function dropConsoleBreadcrumbs(event) {
  return event?.data?.tag === 'breadcrumb' && event.data.payload?.category === 'console' ? null : event
}

export function replayOptions() {
  return {
    maskAllText: true,
    maskAllInputs: true,
    blockAllMedia: true,
    networkDetailAllowUrls: [],
    networkCaptureBodies: false,
    networkRequestHeaders: [],
    networkResponseHeaders: [],
    beforeAddRecordingEvent: dropConsoleBreadcrumbs,
  }
}
